<template>
    <div class="week">
        <button class="week-info" @click="zoomOut(date)">
            {{ getDate(date) }}
        </button>
        <div class="days">
            <div class="hour" v-for="(number, index) in 24" :style="hourStyle">
                {{ ('0' + index).slice(-2) }}
            </div>
        </div>
    </div>
</template>

<script>
import { convert } from '@js-joda/core';
import { mapActions, mapState } from 'vuex';
import { ZOOM_SETTINGS } from '../../constants';

export default {
    data() {
        return {};
    },
    props: ['date'],
    computed: {
        ...mapState('planning', ['currentZoom']),
        hourStyle() {
            const dayOfWeek = this.date.localDate.dayOfWeek().value();
            return {
                width: ZOOM_SETTINGS[this.currentZoom].dayWidth[dayOfWeek] / 24 + 'px',
            };
        },
    },
    methods: {
        ...mapActions('planning', ['zoomOut', 'zoomIn']),
        getDate(date) {
            const jsDate = convert(date.localDate).toDate();

            let options = {
                weekday: 'long',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            };

            return jsDate.toLocaleDateString(window.locale, options);
        },
    },
};
</script>

<style lang="scss">
.week {
    box-sizing: border-box;
    line-height: 25px;
    text-transform: uppercase;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    margin-left: -1px;
    margin-right: -1px;
    &:last-child {
        border-right: 0;
    }
}
.week-info {
    display: block;
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    position: relative;
    line-height: 24px;
    border-bottom: 1px solid #ccc;
    .week-number {
        position: absolute;
        top: 0;
        left: 10px;
    }
}
.days {
    box-sizing: border-box;
    display: inline-flex;
}
.hour {
    box-sizing: border-box;
    display: inline-block;
    border-right: 1px solid #ccc;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    &:last-child {
        border-right: 0;
    }
}
</style>
